import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';
import type { RuleSet } from 'styled-components';

import * as styles from './FreePartnerDeliveryMessage.styles';

export interface FreePartnerDeliveryMessageProps {
  formattedThreshold: string;
  partnerName: string;
  // Not named "css". Next's SWC styled-components transform intercepts a "css" JSX
  // attribute on any element (including custom components) before it reaches this prop.
  styleOverride?: RuleSet<object>;
}

export const FreePartnerDeliveryMessage = ({
  formattedThreshold,
  partnerName,
  styleOverride,
}: FreePartnerDeliveryMessageProps) => (
  <p css={[styles.root, styleOverride]}>
    <Icon name="sale" size="md" />
    <span>
      Spend {formattedThreshold}+ with {partnerName} and get <b>FREE standard delivery</b>
    </span>
  </p>
);
